import InteractionImg1 from "../../../assets/images/interaction_icons/desktop/interaction_d.svg";
import InteractionImg2 from "../../../assets/images/interaction_icons/desktop/zoom_d.svg";
import InteractionImg3 from "../../../assets/images/interaction_icons/desktop/camera_d.svg";
import InteractionImg4 from "../../../assets/images/interaction_icons/mobile/optimized/Camera.png";
import InteractionImg5 from "../../../assets/images/interaction_icons/mobile/optimized/Interaction.png";
import InteractionImg6 from "../../../assets/images/interaction_icons/mobile/optimized/Zoom.png";
import InteractionImg7 from "../../../assets/images/interaction_icons/mobile/optimized/Change_View.png";
import InteractionImg8 from "../../../assets/images/interaction_icons/mobile/optimized/Interaction2.png";

const TEXT_ACTION = 'Kamera drehen';
const TEXT_ZOOM = 'Zoom';
const TEXT_CAMERA_ROTATE = 'Kamera bewegen';
const TEXT_CHANGE_VIEW = 'Ansicht wechseln';
const PREFIX_ID_DESKTOP = 'iid_mouse_';
const PREFIX_ID_MOBILE = 'iid_finger_';

export const INTERACTION_ID_MOUSE_ACTION = `${PREFIX_ID_DESKTOP}action`;
export const INTERACTION_ID_FINGER_ACTION2 = `${PREFIX_ID_MOBILE}action2`;
export const INTERACTION_ID_FINGER_ACTION = `${PREFIX_ID_MOBILE}action`;
export const INTERACTION_ID_MOUSE_CAMERA_ROTATE = `${PREFIX_ID_DESKTOP}camera_rotate`;
export const INTERACTION_ID_FINGER_CAMERA_ROTATE = `${PREFIX_ID_MOBILE}camera_rotate`;
export const INTERACTION_ID_MOUSE_ZOOM = `${PREFIX_ID_DESKTOP}zoom`;
export const INTERACTION_ID_FINGER_ZOOM = `${PREFIX_ID_MOBILE}zoom`;
export const INTERACTION_ID_FINGER_CHANGE_VIEW = `${PREFIX_ID_MOBILE}change_view`;

export const Interaction1 = {
  id: INTERACTION_ID_MOUSE_ACTION,
  img: InteractionImg1,
  name: TEXT_ACTION,
};
export const Interaction2 = {
  id: INTERACTION_ID_MOUSE_ZOOM,
  img: InteractionImg2,
  name: TEXT_ZOOM
};
export const Interaction3 = {
  id: INTERACTION_ID_MOUSE_CAMERA_ROTATE,
  img: InteractionImg3,
  name: TEXT_CAMERA_ROTATE
};
export const Interaction4 = {
  id: INTERACTION_ID_FINGER_CAMERA_ROTATE,
  img: InteractionImg4,
  name: TEXT_CAMERA_ROTATE
};
export const Interaction5 = {
  id: INTERACTION_ID_FINGER_ACTION,
  img: InteractionImg5,
  name: TEXT_ACTION
};
export const Interaction6 = {
  id: INTERACTION_ID_FINGER_ZOOM,
  img: InteractionImg6,
  name: TEXT_ZOOM
};
export const Interaction7 = {
  id: INTERACTION_ID_FINGER_CHANGE_VIEW,
  img: InteractionImg7,
  name: TEXT_CHANGE_VIEW
};
export const Interaction8 = {
  id: INTERACTION_ID_FINGER_ACTION2,
  img: InteractionImg8,
  name: TEXT_ACTION
};

const Interactions = [
  Interaction1,
  Interaction2,
  Interaction3,
  Interaction4,
  Interaction5,
  Interaction6,
  Interaction7,
  Interaction8,
];

export default Interactions;